import LogoIcon from "../../../statics/svgs/LogoIcon";
function HeaderLogo() {
    return (
        <LogoIcon />
    )
}
export default HeaderLogo;